import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=2a6971aa&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6971aa",
  null
  
)

export default component.exports